var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89178 2.60815C12.2997 2.60815 13.5037 2.60815 14.2518 3.35622C14.9999 4.10429 14.9999 5.30827 14.9999 7.71626V9.41897C14.9999 11.8269 14.9999 13.0309 14.2518 13.779C13.5037 14.5271 12.2997 14.5271 9.89178 14.5271",
    stroke: "#172B4D",
    strokeWidth: 1.22973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 16.1351L7.99988 0.999998",
    stroke: "#172B4D",
    strokeWidth: 1.22973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10809 2.60815C3.70013 2.60815 2.49615 2.60815 1.74807 3.35622C0.999986 4.10429 0.999986 5.30827 0.999986 7.71626V9.41897C0.999986 11.8269 0.999986 13.0309 1.74807 13.779C2.49615 14.5271 3.70013 14.5271 6.10809 14.5271",
    stroke: "#172B4D",
    strokeWidth: 1.22973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.8071b68876f8221f150bb5b4a5fa048c.svg";
export { ForwardRef as ReactComponent };